<template>
  <div :class="jel_getClassObject(content)">
    <avatar username="TO DO"></avatar>
    TODO: EnteteInfosPersonnelles
  </div>
</template>

<script>
import Avatar from 'vue-avatar';

export default {
  name: 'CompteEnteteInfosPersonnelles',
  components: { Avatar },
  props: { content: { type: Object, required: true } },
};
</script>
